import { render, staticRenderFns } from "./CupBracketBoard.vue?vue&type=template&id=29ac7815&scoped=true&"
import script from "./CupBracketBoard.vue?vue&type=script&lang=js&"
export * from "./CupBracketBoard.vue?vue&type=script&lang=js&"
import style0 from "./CupBracketBoard.vue?vue&type=style&index=0&id=29ac7815&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ac7815",
  null
  
)

export default component.exports